"use client";

import { DESKTOP_MAX_SIZE } from "@/constants/screen";
import styled from "styled-components";

export const LayoutWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  @media (${({ theme }) => theme.screens.tablet}) {
    max-width: ${DESKTOP_MAX_SIZE};
    border: 2px solid ${({ theme }) => theme.colors.stroke.lighterGrey};
    border-radius: ${({ theme }) => theme.borderRadius.S};
    margin: 0 auto;
  }
`;

export const PageContainer = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: center;
  overflow-y: auto;
  width: 100%;
`;
